import { Component } from 'react';
import { API_ENDPOINT } from '../../constants';
import ListBuilder from '../../components/listBuilder';
import Page from '../../containers/page';
import { updateParamsHelper, getParamsFromURL } from '../../helpers/custom.helper';
import { Container, Row, Col } from 'reactstrap';

class PatientPrescriptionCronLogs_SWEDEN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: 'tsCreated',
                sortType: -1,
                filter: '',
            },
            loading: true,
            initialList: [],
            error: null,
            statusFilter: '',
            modified: 'Not modified'.translate(this.props.lang),
        };
    }

    get = async () => {
        this.setState({
            loading: true,
            initialList: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        try {
            const response = await fetch(
                `${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionCronLogs/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupAlias: localStorage.getItem('groupAlias'),
                        groupId: this.props._groupId || null,
                        total: this.state.total,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        sortField: this.state.params?.sortField,
                        sortType: this.state.params?.sortType,
                        filter: this.state.params?.filter,
                    }),
                }
            );

            const data = await response.json();

            if (data.items) {
                const newState = {
                    loading: false,
                    initialList: data.items,
                    total: data.total,
                };

                if (data.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        data.tsModified,
                        this.props.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (data.error) {
                    errState.error = data.error;
                }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching prescription cron logs for Sweden',
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.initialList) {
                this.setState({
                    loading: false,
                    initialList: this.props.initialList,
                });
            } else {
                this.get();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.patientId !== this.props.patientId ||
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view
        ) {
            this.setState({
                loading: true,
                initialList: [],
                modified: 'Not modified'.translate(this.props.lang),
            });

            this.get();
        }
    }

    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    render() {
        let params = this.state.params;

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel aeb-panel'>
                                <div className='panel-header'>
                                    <h5 className='component-header'>
                                        {'Prescription cron logs - Sweden'.translate(this.props.lang)}
                                    </h5>

                                </div>

                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    hideEntries={false}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', label: 'Type'.translate(this.props.lang), name: 'type' },
                                        { type: 'text', label: 'File'.translate(this.props.lang), name: 'file' },
                                        { type: 'text', label: 'Created at'.translate(this.props.lang), name: 'tsCreatedFormatted' },
                                        { type: 'text', label: 'Updated at'.translate(this.props.lang), name: 'tsModifiedFormatted' },
                                        { type: 'text', label: 'Duration'.translate(this.props.lang), name: 'duration' },
                                        { type: 'text', label: 'Is loading'.translate(this.props.lang), name: 'isLoadingFormatted' },
                                        { type: 'text', label: 'Is finished'.translate(this.props.lang), name: 'isFinishedFormatted' },
                                    ]}
                                    items={this.state?.initialList?.map((item) => {
                                        const formatTs = (ts) => {
                                            if (!ts) return '-';
                                            return new Date(ts * 1000).toLocaleString('sv-SE');
                                        };
                                        return {
                                            ...item,
                                            file: <div style={{ fontWeight: 600 }}>{item?.file}</div>,
                                            type: <div style={{ fontWeight: 600 }}>{item?.type}</div>,
                                            tsCreatedFormatted: formatTs(item?.tsCreated),
                                            tsModifiedFormatted: formatTs(item?.tsModified),
                                            duration: item?.tsCreated && item?.tsModified ? `${item.tsModified - item.tsCreated}s` : '-',
                                            isLoadingFormatted: item?.isLoading ? 'Yes' : 'No',
                                            isFinishedFormatted: item?.isFinished ? 'Yes' : 'No',
                                        };
                                    })}
                                    actions={[]}
                                    rawItems={this.state.items}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Page(PatientPrescriptionCronLogs_SWEDEN);